import React, { ElementType } from 'react';

import { SxProps, Theme } from '@mui/material';

import * as Styled from './styled';
import { StyledListItem } from './styled';

interface ContentCardProps {
	logo?: string;
	text?: string;
	as?: ElementType;
	textStyle?: SxProps<Theme>;
	wrapperStyle?: SxProps<Theme>;
}

function ContentCard({ logo, text, as = 'p', textStyle, wrapperStyle }: ContentCardProps) {
	return (
		<Styled.StyledCard isLogo={!!logo} sx={wrapperStyle}>
			{logo ? (
				<Styled.Logo src={logo} alt="logo" />
			) : (
				<StyledListItem variant="body2" as={as} sx={textStyle}>
					{text}
				</StyledListItem>
			)}
		</Styled.StyledCard>
	);
}

export default ContentCard;
